import { getTourSteps } from '@/tours/tourSteps';
import axios from 'axios';
import { driver, Driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useI18n } from 'vue-i18n';
import { endpointsList } from '@/helpers';
import { WebTour } from 'types';

export function useTour() {
  const { t } = useI18n();

  async function startTour(
    tourKey: WebTour,
    reapeat?: boolean,
  ): Promise<Driver | null> {
    const tourStarted = (
      await axios.get(endpointsList.userSettings.wasWebTourSeen(tourKey))
    ).data;

    if (!tourStarted || reapeat) {
      const driverObj = driver({
        showProgress: true,
        animate: true,
        allowClose: true,
        doneBtnText: t('tours.doneBtnText'),
        nextBtnText: t('tours.nextBtnText'),
        prevBtnText: t('tours.prevBtnText'),
        onDestroyed: async () => {
          await axios.patch(endpointsList.userSettings.setWebTourSeen(tourKey));
        },
      });
      driverObj.setSteps(getTourSteps(tourKey, t));
      driverObj.drive();
      return driverObj;
    }
    return null;
  }

  return { startTour };
}
